import type { App } from 'vue'
import { installI18n } from './i18n'
import { installPinia } from './pinia'

/**
 * Installer 函数类型
 */
export type Installer = (app: App) => Promise<void> | void | Promise<unknown> | unknown

/**
 * 已注册的 installers 列表
 *
 * 注意：Pinia 必须在 i18n 之前安装，因为 I18nStore 依赖于 Pinia
 */
const installers: Installer[] = [
  installPinia,  // 先安装 Pinia
  installI18n,   // 再安装 i18n
  // 在这里添加更多的 installers
  // installAxios,
  // installVuetify,
]

/**
 * 安装所有插件
 * @param app Vue 应用实例
 */
export const installPlugins = (app: App) => {
  console.group('🔧 Installing Plugins')

  for (const installer of installers) {
    try {
      installer(app)
    } catch (error) {
      console.error(`❌ Failed to install plugin:`, error)
      throw error
    }
  }

  console.groupEnd()
}

/**
 * 注册自定义 installer
 * @param installer Installer 函数
 */
export const registerInstaller = (installer: Installer) => {
  installers.push(installer)
}

/**
 * 批量注册 installers
 * @param installers Installer 函数数组
 */
export const registerInstallers = (...newInstallers: Installer[]) => {
  installers.push(...newInstallers)
}
